import { useQuery } from '@tanstack/react-query';
import { useGql } from '@ah/design';
import { Header, PillTabs, PullToRefresh, type PillTab } from '@ah/design/mobile';
import { Video } from 'lucide-react';
import { VIDEOS_LIST_QUERY, type VideoListItem } from '../shared/index.ts';
import { VideoRow, VideoListSkeleton, ErrorRetry } from './_parts.tsx';

const TABS: PillTab[] = [
  { to: '/videos',          label: 'For You', end: true },
  { to: '/videos/latest',   label: 'Latest' },
  { to: '/videos/channels', label: 'Channels' },
  { to: '/videos/seen',     label: 'Watched' },
  { to: '/videos/saved',    label: 'Saved' },
];

export function Videos() {
  const gql = useGql();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['videos', 'list'],
    queryFn: async () => {
      const res = await gql.request<{ videos: VideoListItem[] }>(VIDEOS_LIST_QUERY);
      return res.videos;
    },
    refetchInterval: 60_000,
  });

  return (
    <div className="fixed inset-0 flex flex-col bg-background">
      <Header title="Videos" />
      <PillTabs tabs={TABS} />
      <PullToRefresh className="flex-1 px-3 py-3" onRefresh={() => refetch()}>
        {isLoading ? (
          <VideoListSkeleton />
        ) : error ? (
          <ErrorRetry label="Could not load videos." onRetry={() => refetch()} />
        ) : !data || data.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">
            <Video size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">No video summaries yet — the pipeline is warming up.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {data.map((v) => <VideoRow key={v.id} v={v} />)}
          </div>
        )}
      </PullToRefresh>
    </div>
  );
}
